export default {
  name: "btnBack"
};